import axios from 'axios';
// import Swiper core and required modules
import { Navigation, Lazy, A11y } from 'swiper';
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';
import loadingAnimation from '../loading-animation.vue';
import axiosError from '../axios-error.vue';
import Modal from '../modal/modal.vue';
import { freeShipping } from '../mixins/freeShipping';

export default {
  name: 'sidecart',
  components: {
    Swiper,
    SwiperSlide,
    loadingAnimation,
    axiosError,
    Modal,
  },
  mixins: [freeShipping],
  props: [],
  setup() {
    const onSwiper = (swiper) => {};
    const onSlideChange = () => {};
    return {
      pagination: {
        clickable: true,
      },
      onSwiper,
      onSlideChange,
      modules: [Navigation, Lazy, A11y],
    };
  },
  data() {
    return {
      cartLoading: false,
      refreshing: false,
      error: false,
      cart: {
        items: [],
        total_price: 0,
      },
      discounts: [],
      // widgets for discounts, eg. spend X get Y
      widgets: [],
      eventEmitter: {},
      //used to force refresh when a call is made from outside of the app (open cart when adding to cart).
      //renderComponent: true
      //cart mixin provides 'cart'
    };
  },
  computed: {
    checkoutButtonUrl() {
      //return window.location.href.includes('/cart') ? '/checkout' : '/cart';
      // returning cart here while Kirby A/B tests the page.
      return '/checkout';
    },
  },
  methods: {
    cartContainsShippableItem() {
      for (var i = 0; i < this.cart.items.length; i++) {
        if (this.cart.items[i].requires_shipping) {
          return true;
        }
      }
      return false;
    },
    cartContainsRouteInsuranceItem() {
      for (var i = 0; i < this.cart.items.length; i++) {
        if (this.cart.items[i].product_id === 3940285775933) {
          return true;
        }
      }
      return false;
    },
    cartContainsDonationCheckboxItem() {
      for (var i = 0; i < this.cart.items.length; i++) {
        if (this.cart.items[i].variant_id === 40511363612733) {
          return true;
        }
      }
      return false;
    },
    toggleDonationItem() {
      if (this.cartContainsDonationCheckboxItem()) {
        this.updateItem(40511363612733, 0);
      } else {
        this.addItem(40511363612733);
      }
    },
    toggleRouteItem() {
      if (this.cartContainsRouteInsuranceItem()) {
        this.updateItem(39947795988541, 0);
      } else {
        this.addItem(39947795988541);
      }
    },
    isChoiceItem(lineItem) {
      return lineItem.title.toLowerCase().includes('ddc_');
    },

    // updateChoiceLineItemImages() {
    // 	this.cart.items.forEach(cartItem => {
    // 		//if this line item is a choice item
    // 		if((cartItem.sku).toLowerCase().includes('ddc_')) {
    // 			//cartItem.isChoice = true;
    // 	  		cartItem.disablePlusButton = true;
    // 		}
    // 	});
    // },

    //Core cart functions
    cartToggle() {
      let sideCartClassList = document.getElementById('sidecart').classList;
      if (sideCartClassList.contains('sidecart-open')) {
        this.closeCart();
      } else {
        this.openCart();
      }
    },
    //used to open the side cart
    openCart() {
      // check for discount updates
      this.refreshDiscountData();
      this.getCart();
      // open the cart by attaching class
      let sideCartClassList = document.getElementById('sidecart').classList;
      if (!sideCartClassList.contains('sidecart-open')) {
        document.getElementById('sidecart').classList.add('sidecart-open');
      }
    },

    //slide the cart off screen
    closeCart() {
      let sideCartClassList = document.getElementById('sidecart').classList;
      if (sideCartClassList.contains('sidecart-open')) {
        document.getElementById('sidecart').classList.remove('sidecart-open');
      }
      document.querySelector('.coto_header').classList.remove('cart-squish');
    },
    //get the current state of the cart from Shopify.
    getCart(updateDY, showLoading) {
      if (showLoading) this.cartLoading = true;
      return (
        axios
          //.get(this.shopifyLocale + `/cart.js`)
          .get(`/cart.js`)
          .then((response) => {
            this.cart = response.data;
            this.cartLoading = false;
            //update number on the cart icon
            document.getElementById('CartCount').textContent =
              this.cart.item_count > 0 ? this.cart.item_count : '';
            //DY sync cart event
            if (updateDY) {
              this.DYSyncCart();
              //also emit request complete when the cart is changed
            }
            this.emitRequestComplete();
          })
          .catch((error) => {
            //console.log(error);
            this.cartLoading = false;
          })
      );
    },
    //just return the cart object that we have. Used by Kirby for promo calculation.
    getCartObject() {
      return this.cart;
    },
    //used to add items to the cart.
    //only requires variantID.
    addItem(variantId, quantity = 1, properties = {}) {
      let payload = {
        items: [
          {
            quantity: quantity,
            id: variantId,
            properties: properties,
          },
        ],
      };
      this.cartLoading = true;
      axios
        .post('/cart/add.js', payload)
        .then((response) => {
          this.openCart();
          this.cartLoading = false;
        })
        .catch((error) => {
          //console.log(error.response);
          if (error.response.data.description) {
            alert(error.response.data.description);
          } else {
            alert('This product is unavailable.');
          }

          this.cartLoading = false;
        });

      //ERROR RESPONSE when trying to add over the quantity limit:
      // {
      //     "status": 422,
      //     "message": "Cart Error",
      //     "description": "You can't add more Messenger Bag to the cart."
      //   }
    },
    // add multiple items at once, eg. when adding a whole bundle
    addItems(items) {
      this.cartLoading = true;
      axios
        .post('/cart/add.js', { items })
        .then((response) => {
          this.openCart();
          this.cartLoading = false;
        })
        .catch((error) => {
          if (error.response.data.description) {
            alert(error.response.data.description);
          } else {
            alert('One or more products are unavailable.');
          }

          this.cartLoading = false;
        });
    },

    //remove all items from the cart
    clearCart() {
      //use
      /*
            /{locale}/cart/clear
            */
    },

    //update functions
    //update a single line item quantity
    updateItem(key, quantity, openSideCart = true) {
      let payload = {
        updates: {
          //es6, place brackets over attribute to make it dynamic
          [key]: quantity,
        },
      };
      this.cartLoading = true;
      axios
        .post('/cart/update.js', payload)
        .then((response) => {
          //this.cart = response.data
          if (openSideCart) {
            this.openCart();
            this.cartLoading = false;
          }
          this.getCart();
        })
        .catch((error) => {
          alert(error.description);
          this.cartLoading = false;
        });
      // jQuery.post(window.Shopify.routes.root + 'cart/update.js', {
      //     updates: {
      //       794864053: 2,
      //       794864233: 3
      //     }
      //   });

      // ERROR MESSAGES
      // {
      //     "status": 422,
      //     "message": "Cart Error",
      //     "description": "You can only add 8 Messenger Bag to the cart."
      //   }

      // {
      //     "status": 404,
      //     "message": "Cart Error"
      //     "description": "Cannot find variant"
      //   }
    },

    //update multiple items
    updateItems() {},

    //end Core Cart Functions

    filterPrice(price) {
      let formattedPrice = price.toString(); // just in case data is passed through as integer
      if (!formattedPrice.includes('.00')) {
        // keeps decimal places if price does not end in .00
        formattedPrice = parseFloat(formattedPrice).toFixed(2);
      } else {
        formattedPrice = parseFloat(formattedPrice).toFixed(0); // drops $.00 if price is even number
      }
      return `$${formattedPrice}`;
    },
    //we hide some properties (like choice image urls) from appearing in the sidecart information.
    isHiddenProp(item, index) {
      // let hiddenPropNames = ['imageUrl', 'bundle'];
      // if (hiddenPropNames.includes(Object.keys(item.properties)[index])) {
      const itemProperties = Object.entries(item.properties);
      if (itemProperties[index][0].startsWith('_')) {
        return true;
      }
      return false;
    },

    //sync cart event used whenever the cart is manipulated.
    DYSyncCart() {
      //let items = cart.items;
      let DYCartObject = [];
      this.cart.items.forEach((i) => {
        let obj = {
          productId: i.sku,
          quantity: i.quantity,
          itemPrice: i.price / 100, //divide here because this comes from liquid
          size: i.variant_options.length > 1 ? i.variant_options[1] : 'none', // can be any value
        };
        DYCartObject.push(obj);
      });

      DY.API('event', {
        name: 'Sync cart', // Human-readable name, not used to identify an event type
        properties: {
          dyType: 'sync-cart-v1', // Identifies this event as a purchase. Do Not Change.
          cart: DYCartObject,
        },
      });
    },

    // check if makes sense to get bundle data again, then do it if applicable
    refreshDiscountData() {
      axios
        .get(
          `https://production-access-api.cotopaxi.com/discount/getActiveDiscounts`
        )
        .then((response) => {
          if (response.data) {
            const discounts = response.data.discounts;
            const widgets = response.data.widgets;
            // attach discount data to cart
            if (discounts) {
              this.discounts = discounts;
              axios
                .post('/cart/update.js', {
                  attributes: { _discounts: discounts },
                })
                .then((response) => {
                  // console.log(response.data.attributes.discounts);
                })
                .catch((error) => {
                  console.error(error);
                });
            }
            // set widget data
            if (widgets) {
              widgets.forEach((widget) => {
                // if only one product in widget, pre-select first one
                if (widget.products.length == 1)
                  this.selectWidgetProduct(widget, widget.products[0]);
                this.selectWid;
              });
              this.widgets = widgets;
            }
          }
        })
        .catch((error) => console.error(error));
    },
    // select product for discount widget
    selectWidgetProduct(widget, product) {
      widget.selectedProduct = product;
      // select first colorway by default
      const colorway = product.colorways[0];
      this.selectWidgetColorway(widget, colorway);
    },

    // select colorway for the currently viewed widget product
    // used to determine which image & price is shown, and which variant
    // the "Add to cart" button will actually add
    selectWidgetColorway(widget, colorway, delDia = false) {
      if (delDia) {
        // if the selected colorway is the del día version
        widget.selectedProduct.selectedColorway = colorway;
        widget.selectedProduct.selectedColorway.image = colorway.featuredImage;
        widget.selectedProduct.selectedVariant = {
          shopifyVariantId: colorway.shopifyVariantId,
        };
        widget.selectedProduct.showSizes = false;
      } else {
        const firstSize = colorway.sizes[0];
        // select colorway data
        widget.selectedProduct.selectedColorway = colorway;
        // only show sizes if it makes sense
        const showSizes = this.showWidgetProductSizes(firstSize);
        widget.selectedProduct.showSizes = showSizes;
        // if there's no selected variant, pick one
        if (!widget.selectedProduct.selectedVariant) {
          widget.selectedProduct.selectedVariant = colorway.sizes[0];
        } else {
          if (showSizes) {
            // if sizes are important, let's select the variant that matches the same size that
            // was already selected
            const size = colorway.sizes.find(
              (s) => s.name === widget.selectedProduct.selectedVariant.name
            );
            if (size) widget.selectedProduct.selectedVariant = size;
            else {
              // fall back to first size
              widget.selectedProduct.selectedVariant = colorway.sizes[0];
            }
          }
        }
        // if no size has been set already, set the first one that's available
        if (
          widget.selectedProduct.showSizes &&
          !widget.selectedProduct.selectedVariant
        ) {
          widget.selectedProduct.selectedVariant =
            product.colorways[0].sizes[0];
        }
      }
    },

    // determine whether spend threshold for spend x get y widget is met
    widgetSpendStatus(widget) {
      const spendXGetY = widget.spendXGetY;
      let cartValue = this.cart.total_price;
      this.cart.items.forEach((lineItem) => {
        // if item is one of the gwp products, we don't want to count it
        if (this.excludedFromShippingThreshHold(lineItem)) {
          //remove final line price, as it includes quantity + any applied discounts
          cartValue -= lineItem.final_line_price;
        }
      });
      const spendThreshold = spendXGetY.dollarThreshold;
      const spendThresholdInCents = spendThreshold * 100;
      const distanceToThreshold =
        spendThresholdInCents - cartValue < 0
          ? 0
          : (spendThresholdInCents - cartValue) / 100;
      const thresholdMet = distanceToThreshold === 0;
      const percentToThreshold =
        ((spendThreshold - distanceToThreshold) / spendThreshold) * 100;
      return { distanceToThreshold, thresholdMet, percentToThreshold };
    },

    // determine whether gwp widget has been fully redeemed
    widgetGwpRedeemed(widget) {
      // find discount data so we can get the product ids
      const discount = this.discounts.find(
        (d) => d.discountId === widget.discountId
      );
      const limit = widget.spendXGetY.quantityAllowed;
      if (discount && limit) {
        let productsRedeemed = 0;
        const productIds = discount.groups[0].products;
        // iterate through cart line items, we are looking for products
        // that have a matching product id and a final_line_price of 0 (free),
        // these have been discounted according to the spend X get Y logic
        this.cart.items.forEach((item) => {
          const itemMatchesDiscount = productIds.find(
            (i) => Number(i) === item.product_id
          );
          if (itemMatchesDiscount && item.final_line_price == 0) {
            productsRedeemed += item.quantity;
          }
        });
        console.log(productsRedeemed >= limit);
        return productsRedeemed >= limit;
      } else return false;
    },

    // determine whether product in widget should show sizes
    showWidgetProductSizes(variant) {
      return !(
        variant.name.toLowerCase() === 'one size' ||
        variant.name.toLowerCase().includes('bundle') ||
        variant.name.toLowerCase().includes('only') ||
        variant.name.toLowerCase() === 'null' ||
        variant.name == null
      );
    },
    //event emitter for Optimize promotion functionality.
    // $(document).on('cart.requestComplete', function(event, cart) {
    // 	// Event handling here.
    // 	//lastCartValue = adjustedCartValue(cart);
    // 	console.log(cart);
    //   });

    initEventEmitter() {
      function EventEmitter() {
        this.events = {};
      }

      EventEmitter.prototype.on = function (eventName, callback) {
        if (!this.events[eventName]) {
          this.events[eventName] = [];
        }
        this.events[eventName].push(callback);
      };

      EventEmitter.prototype.emit = function (eventName, data) {
        if (this.events[eventName]) {
          this.events[eventName].forEach((callback) => {
            callback(data);
          });
        }
      };

      this.eventEmitter = new EventEmitter();

      //this.subscribeToEvent();
    },

    // subscribeToEvent() {
    // 	// Subscribe to an event
    // 	this.eventEmitter.on('requestComplete', data => {
    // 		console.log('Event triggered with data:', data);
    // 	});
    // },

    emitRequestComplete() {
      // Emit the event
      this.eventEmitter.emit('requestComplete', this.cart);
    },
  },
  mounted() {
    this.initEventEmitter();
    this.getCart(false, true);
    this.initEventEmitter();

    //mounted ensures dom is ready, so we can attach to the cart icon
    document.querySelector('.cart').addEventListener('click', function () {
      vueSideCart.openCart();
    });
  },
};
